// extracted by mini-css-extract-plugin
export default {"vertical_list":"ProgramLevelSubContant1_vertical_list__7E8Jm","pointed_list":"ProgramLevelSubContant1_pointed_list__WdEZM"};